import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/napster': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zM342.3 174c-56.4-39.8-132.1-39.9-188.9 0.1-19.9-16.8-43.6-29.5-69.5-36.4v161.6c0 217.3 328 219.1 328-0.3v-161.2c-26 7-49.6 19.3-69.6 36.2zM133.5 115.5c6.5 3.2 14.1 7.4 20.4 11.4 58.7-30.5 129.2-30.6 187.9-0.1 6.7-4.2 13.5-8 20.6-11.5-64.6-59.9-164.5-59.8-228.9 0.2zM43.8 93.2c17.5 0.5 34.3 3.1 50.6 7.5 82-91.6 225.5-91.6 307.5-0.1 16.1-4.4 32.8-6.9 50.1-7.4v69.2c58.7 36.5 58.5 121.9-0.2 158.2l-0.3 1.7c-25.9 238.8-381.2 243.6-407.6-1.5-58.5-37.2-58.5-121.8-0.1-158.3v-69.3zM259.2 352c13.1-59.3 33.5-56 113-55.4-0.8 8.2 0.1 32.3-26.2 47.4-4.4 2.5-15.3 6-25.5 6.5-25.3 1.2-61.3 1.5-61.3 1.5zM123.7 296.7c79.3-0.7 99.8-4 113 55.4 0 0-36-0.4-61.3-1.5-10.3-0.5-21.1-4-25.5-6.5-26.3-15.1-25.4-39.2-26.2-47.4zM292.8 420.1c3 4.9 3.2 8.8 3.3 8.9-29.1 17.6-67.1 17.6-96.2 0 0 0 0.9-5.5 3.7-9.6 3.5-5.1 6.4-6.6 6.4-6.6 23.7 6.9 51.1 7.3 75.9 0 0 0 3.7 2 6.9 7.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/napster.js
// module id = 942
// module chunks = 0